export const initCompC0016 = () => {

    document.addEventListener("DOMContentLoaded", function () {
        //LIFERAY
        // Este init se ejecuta en todas las paginas del portal, pero el carrusel solo existe
        // en algunas. Sin esta guarda, las que no lo tienen lanzaban un ReferenceError en
        // cuanto el theme dejo de cargar swiper-bundle.js en todas partes.
        //
        // La condicion envuelve el bloque en vez de hacer un return temprano a proposito:
        // bin/gulpfile.cjs recorta literalmente lo que hay entre las dos marcas de comentario
        // que delimitan este bloque para generar el index.js del fragmento, y un return en el
        // nivel superior de ese recorte rompe la minificacion ("'return' outside of function"
        // en terser). Por el mismo motivo, no escribir aqui esas marcas: cortarian el recorte.
        if (typeof Swiper !== "undefined" && document.querySelector(".mySwiper")) {
            var swiper = new Swiper(".mySwiper", {
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                    },
                    768: {
                        slidesPerView: 2,
                    },
                    1024: {
                        slidesPerView: 4,
                    },
                },
                centeredSlides: false,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                pagination: {
                    el: ".swiper-pagination",
                    type: "bullets",
                    clickable: true,
                },
                autoHeight: true,
                spaceBetween: 20,
            });

            var setEqualHeight = function () {
                let maxHeight = 0;
                const slides = document.querySelectorAll(".swiper-slide .col");

                slides.forEach((slide) => {
                    slide.style.height = "auto"; // Reset height
                    const slideHeight = slide.clientHeight;
                    if (slideHeight > maxHeight) {
                        maxHeight = slideHeight;
                    }
                });

                slides.forEach((slide) => {
                    slide.style.height = `${maxHeight}px`;
                });
            };

            // Set equal height on initial load
            setEqualHeight();

            // Set equal height on slide change (for dynamic content)
            swiper.on("slideChange", function () {
                setEqualHeight();
            });

            // Set equal height on window resize
            window.addEventListener("resize", function () {
                setEqualHeight();
            });
        }
        //END LIFERAY
    });

};

initCompC0016();

export const initCompC0033 = function () {

    document.addEventListener("DOMContentLoaded", function () {
        //LIFERAY
        var btn = document.getElementById('filtrar-btn');
        var closeBtn = document.getElementById('close-btn');
        var wrapper = document.querySelector('.c0033-contentlist__listwrap');
        var isMobile = window.matchMedia('(max-width: 768px)').matches;

        if (wrapper) {

            if (btn) {

                btn.addEventListener('click', function () {
                    if (isMobile) {
                        wrapper.classList.toggle('filter-modal-active');
                    } else {
                        wrapper.classList.toggle('filter-active');

                        setTimeout(function () {
                            btn.classList.toggle('active');
                        }, 500);
                    }

                });
            }

            if (closeBtn) {

                closeBtn.addEventListener('click', function () {
                    wrapper.classList.remove('filter-modal-active');
                });
            }
        }
        //END LIFERAY
    })
}




export const initCompC0019 = () => {
//LIFERAY
    // Manejo de la visibilidad de la contraseña
  const togglesPassword = document.querySelectorAll(".togglePassword");
  if (togglesPassword) {
    togglesPassword.forEach(function (togglePassword) {
      togglePassword.onclick = function () {
        const passwordInput = this.parentNode.querySelector(
          "input[type='password'], input[type='text']"
        );
        if (passwordInput) {

          const currentType = passwordInput.getAttribute("type");

          const newType = currentType === "password" ? "text" : "password";
          passwordInput.setAttribute("type", newType);

          this.setAttribute(
            "title",
            newType === "password"
              ? "Mostrar contraseña"
              : "Ocultar contraseña"
          );
          this.classList.toggle("showing");
        } else {
          console.error("El campo de contraseña no se encontró.");
        }
      }
    });
  }

  // Autosize para textarea
  function autosizeTextArea(textArea) {
    if (textArea) {
      textArea.style.height = "0px";
      const scrollHeight = textArea.scrollHeight;

      textArea.style.height = scrollHeight + "px";
    }
  }

  const textAreas = document.querySelectorAll("textarea");
  textAreas.forEach((textArea) => {
    autosizeTextArea(textArea);

    textArea.addEventListener("input", function () {
      autosizeTextArea(textArea);
    });
  });

  // Función para cambiar el color del label en switch
  const switchInput = document.getElementById('switch1');
  const label = document.querySelector('.form-check-label');

  if (switchInput)
    if (switchInput.disabled) {
      label.classList.add('disabled-label');
    }

  // Función para el conteo de caracteres
  function updateRemainingCharacters(event) {
    const textarea = event.target;
    const maxLength = textarea.maxLength;
    const remainingChars = maxLength - textarea.value.length;
    const feedbackElement = textarea.parentNode.querySelector(".form-text");

    if (feedbackElement && feedbackElement.classList.contains("form-text")) {
      feedbackElement.textContent = `Quedan ${remainingChars} caracteres`;
    }
  }

  function initCharacterCount(selector) {
    const textareas = document.querySelectorAll(selector);
    textareas.forEach((textarea) => {
      textarea.addEventListener("input", updateRemainingCharacters);
      updateRemainingCharacters({ target: textarea });
    });
  }

  initCharacterCount("textarea.char-count");

  // Manejo de placeholder en los inputs
  const inputs = document.querySelectorAll(
    'input[type="text"], input[type="password"]'
  );

  inputs.forEach((input) => {
    const handlePlaceholder = () => {
      input.placeholder = input.value ? "" : input.dataset.placeholder;
    };

    input.dataset.placeholder = input.placeholder;

    input.addEventListener("input", handlePlaceholder);
    input.addEventListener("blur", handlePlaceholder);
    input.addEventListener("focus", handlePlaceholder);

    handlePlaceholder();
  });
//END LIFERAY
};

document.addEventListener('DOMContentLoaded', function() {
  initCompC0019();
})

export const initCompC0019select = () => {
  document.addEventListener("DOMContentLoaded", function () {
    //LIFERAY
    $("#select1").each(function () { //TODO - ESTO NO VA A FUNCIONAR PARA TODOS LOS SELECTS!!!

      const addPlaceholderClass = (selectElement) => {
        const elements = document.querySelectorAll(".token.tag.attr-value");
        let targetElement = null;
        if (elements.length > 0) {
          for (const element of elements) {
            if (element.textContent.includes("form-control")) {
              targetElement = element;
              break;
            }
          }
        }
        if (selectElement.value === "") {
          selectElement.classList.add("placeholder");
          if (
            targetElement &&
            !targetElement.textContent.includes("placeholder")
          ) {
            targetElement.textContent += " placeholder";
          }
        } else {
          selectElement.classList.remove("placeholder");
          if (
            targetElement &&
            targetElement.textContent.includes("placeholder")
          ) {
            targetElement.textContent = targetElement.textContent.replace(
              " placeholder",
              ""
            );
          }
        }
      };

      const selectElement = document.querySelector("#select1");

      selectElement.addEventListener("change", (event) => {
        addPlaceholderClass(event.target);
      });

      addPlaceholderClass(selectElement);
    });
    //END LIFERAY
  });
};

initCompC0019select();

export const initCompTextareaC0019 = () => {

    // document.addEventListener("DOMContentLoaded", function () {
//LIFERAY
        function autosizeTextArea(textArea) {
            if (textArea) {
                textArea.style.height = "0px";
                const scrollHeight = textArea.scrollHeight;

                textArea.style.height = scrollHeight + "px";
            }
        }

        const textAreas = document.querySelectorAll("textarea");

        textAreas.forEach((textArea) => {
            autosizeTextArea(textArea);

            textArea.addEventListener("input", function () {
                autosizeTextArea(textArea);
            });
        });

        // Función para el conteo de caracteres
        function updateRemainingCharacters(event) {
            const textarea = event.target;
            const maxLength = textarea.maxLength;
            const remainingChars = maxLength - textarea.value.length;
            const feedbackElement = textarea.parentNode.querySelector(".form-text");

            if (feedbackElement && feedbackElement.classList.contains("form-text")) {
                feedbackElement.textContent = `Quedan ${remainingChars} caracteres`;
            }
        }

        function initCharacterCount(selector) {
            const textareas = document.querySelectorAll(selector);

            textareas.forEach((textarea) => {
                textarea.addEventListener("input", updateRemainingCharacters);
                updateRemainingCharacters({target: textarea});
            });
        }

        initCharacterCount("textarea.char-count");
    // });
    //END LIFERAY
};

// initCompTextareaC0019();
  
export const initCompC0024 = () => {
    document.addEventListener("DOMContentLoaded", function () {
        //LIFERAY
        const nav = document.querySelector(".nav-desktop-secondary");
        const sentinel = document.getElementById("header_sentinel");

        if (sentinel) {
            const observer = new IntersectionObserver(
                ([entry]) => {
                    if (!entry.isIntersecting) {
                        nav.classList.add("sticky");
                    } else {
                        nav.classList.remove("sticky");
                    }
                },
                {rootMargin: "0px 0px 0px 0px", threshold: 0}
            );

            observer.observe(sentinel);
        }


        // Click to open/close nav dropdowns
        const navItems = document.querySelectorAll(".nav-desktop-secondary .nav-item.has-children");

        navItems.forEach(function(navItem) {
            var navLink = navItem.querySelector(".m-main-nav-desk .nav-link");
            var btnMenu = navItem.querySelector(".m-main-nav-desk .m-btn-menu");

            function toggleMenu(event) {
                event.preventDefault();
                event.stopPropagation();
                var isOpen = navItem.classList.contains("open");

                // Close all open menus
                navItems.forEach(function(item) {
                    item.classList.remove("open");
                    var link = item.querySelector(".m-main-nav-desk .nav-link");
                    if (link) link.setAttribute("aria-expanded", "false");
                });

                // Toggle current
                if (!isOpen) {
                    navItem.classList.add("open");
                    if (navLink) navLink.setAttribute("aria-expanded", "true");
                }
            }

            if (navLink) navLink.addEventListener("click", toggleMenu);
            if (btnMenu) btnMenu.addEventListener("click", toggleMenu);
        });

        // Close menu on mouse leave with delay
        navItems.forEach(function(navItem) {
            var leaveTimer = null;

            navItem.addEventListener("mouseleave", function() {
                leaveTimer = setTimeout(function() {
                    navItem.classList.remove("open");
                    var link = navItem.querySelector(".m-main-nav-desk .nav-link");
                    if (link) link.setAttribute("aria-expanded", "false");
                }, 300);
            });

            navItem.addEventListener("mouseenter", function() {
                if (leaveTimer) {
                    clearTimeout(leaveTimer);
                    leaveTimer = null;
                }
            });
        });

        // Close menu on click outside
        document.addEventListener("click", function(event) {
            if (!event.target.closest(".nav-desktop-secondary .nav-item")) {
                navItems.forEach(function(item) {
                    item.classList.remove("open");
                    var link = item.querySelector(".m-main-nav-desk .nav-link");
                    if (link) link.setAttribute("aria-expanded", "false");
                });
            }
        });

        // Dismiss menu buttons
        const dismissMenus = document.querySelectorAll(".nav-desktop-secondary .dismiss-menu");

        dismissMenus.forEach(function(dismissMenu) {
            dismissMenu.addEventListener("click", function (event) {
                var navItem = event.target.closest('.nav-item');
                if (navItem) {
                    navItem.classList.remove("open");
                    var link = navItem.querySelector(".m-main-nav-desk .nav-link");
                    if (link) {
                        link.setAttribute("aria-expanded", "false");
                        link.focus();
                    }
                }
            });
        });

        if (document.getElementById('header_search_button')) {
            document.getElementById('header_search_button').addEventListener('click', function () {

                var hiddenElement = this.parentNode.querySelector('.d-none');

                if (hiddenElement) {
                    hiddenElement.classList.remove('d-none'); // Eliminar la clase 'd-none'
                }
                document.querySelector('.header-actions .search-form .form-control').focus();

                this.classList.add('d-none');
            });
        }

        if (document.querySelector('#menu-mobile .btn-menu-mobile-close')) {
            document.querySelector('#menu-mobile .btn-menu-mobile-close').addEventListener('click', function() {
                document.getElementById('menu-mobile').classList.remove('show');

                document.querySelectorAll('.m-menuButton').forEach(function(menuButton) {
                    menuButton.setAttribute('aria-expanded', 'false');
                });
            });
        }
//END LIFERAY

    })
};

initCompC0024();

export const initCompC0002 = () => {
    document.addEventListener('DOMContentLoaded', function () {
        //LIFERAY
        const containers = document.querySelectorAll('.c0002-image.blur');

        containers.forEach(container => {
          const imageUrl = container.querySelector('.main-image').src;
          const uniqueId = container.getAttribute('data-image-id'); 
    
          const style = document.createElement("style");
          style.innerHTML = `
            .c0002-image[data-image-id="${uniqueId}"].blur::before {
              background-image: url("${imageUrl}");
              filter: blur(10px);
            }
          `;
          document.head.appendChild(style);
        });
        //END LIFERAY
    });
};

initCompC0002();
export const initCompC0013 = () => {

    document.addEventListener('DOMContentLoaded', function () {
        //LIFERAY
        $(".c0013-readmore").each(function () {
            var component = $(this).closest(".c0013-readmore");
            var content = $(this).find(".read-more-content");
            var inner = content.find(".read-more-content-inner");
            var toggler = component.find(".read-more-toggler");

            function initializeReadMore() {
                content.data("height", content.height());
                content.css("max-height", content.outerHeight());

                var togglerText = toggler.find("span");
                toggler.data("text-more", "Leer más");
                toggler.data("text-less", "Leer menos");

                var classes = content.attr("class");
                var match = classes.match(/ellipsis-(\d+)/);
                if (match) {
                    var lines = match[1];
                    content.data("lines", lines);
                }

                content.removeClass("ellipsis-" + lines);
                content.data("expanded-height", inner.outerHeight());
                content.addClass("ellipsis-" + lines);

                if (content.data("height") >= content.data("expanded-height")) {
                    toggler.hide();
                    content.removeClass("ellipsis-" + lines);
                    content.addClass("expanded");
                } else {
                    togglerText.html(toggler.data("text-more"));
                    content.addClass("ellipsis-" + lines).removeClass("expanded");
                    toggler.show();
                }
            }

            initializeReadMore();

            $(window).resize(function () {
                initializeReadMore();
            });
        });

        $(".read-more-toggler")
            .unbind("click")
            .click(function (e) {
                e.preventDefault();
                var component = $(this).closest(".c0013-readmore");
                var content = component.find(".read-more-content");
                var toggler = component.find(".read-more-toggler");
                var togglerText = toggler.find("span");

                var classes = content.attr('class').split(/\s+/);
                var stepLines = 30

                if (!content.hasClass("expanded")) {
                    var ellipsisClass = classes.find(function (className) {
                        return className.startsWith('ellipsis-');
                    });

                    var lines = ellipsisClass.split('-')[1];
                    content.removeClass("ellipsis-" + lines).addClass("ellipsis-" + ((lines * 1) + stepLines))
                    content.css("max-height", '');
                    setTimeout(function(){

                        if ((content.outerHeight() * 1.1) >= content.data("expanded-height")) {
                            content.removeClass("ellipsis-" + ((lines * 1) + stepLines)).addClass("expanded");
                            toggler.addClass("expanded");
                            togglerText.html(toggler.data("text-less"));
                            content.css("max-height", content.data("expanded-height"));
                        }
                    }, 100)

                } else {
                    togglerText.html(toggler.data("text-more"));
                    content.css("max-height", content.data("height"));
                    toggler.removeClass("expanded");
                    setTimeout(() => {
                        content.addClass("ellipsis-" + content.data("lines")).removeClass("expanded");
                    }, 500);
                }
            });
        //END LIFERAY
    })

}

initCompC0013();
export const initCompC0025 = () => {
  document.addEventListener("DOMContentLoaded", function () {
    //LIFERAY
    const dropdownItems = document.querySelectorAll(".nav-item.dropdown");

    // Mostrar u ocultar el menú principal
    dropdownItems.forEach((item) => {
      let timeout;

      item.addEventListener("mouseenter", () => {
        clearTimeout(timeout); // Cancelar el cierre si se vuelve a entrar
        const menu = item.querySelector(".dropdown-menu");
        const icon = item.querySelector(".nav-link i, .dropdown-toggle i"); // Seleccionar el ícono del primer nivel

        if (menu) {
          item.classList.add("show");
          menu.classList.add("show");

          // Rotar el ícono
          if (icon) {
            icon.classList.add("icon-rotate");
          }
        }
      });

      item.addEventListener("mouseleave", () => {
        // Retraso antes de cerrar para evitar que cierre mientras navegas hacia un submenú
        timeout = setTimeout(() => {
          const menu = item.querySelector(".dropdown-menu");
          const icon = item.querySelector(".nav-link i, .dropdown-toggle i"); // Seleccionar el ícono del primer nivel

          if (menu) {
            item.classList.remove("show");
            menu.classList.remove("show");

            // Restaurar el ícono
            if (icon) {
              icon.classList.remove("icon-rotate");
            }
          }
        }, 0);
      });
    });

    // Manejo de submenús
    const subMenus = document.querySelectorAll(".dropdown-item.has-submenu");

    subMenus.forEach((subMenu) => {
      let timeout;

      subMenu.addEventListener("mouseenter", function () {
        clearTimeout(timeout); // Cancelar el cierre si se vuelve a entrar
        const siblingSubMenu = this.nextElementSibling;

        if (siblingSubMenu) {
          siblingSubMenu.classList.add("sub-item-show");
          this.setAttribute("aria-expanded", "true");

          const icon = this.querySelector("i");
          if (icon) {
            icon.classList.add("icon-rotate");
          }
        }
      });

      subMenu.addEventListener("mouseleave", function () {
        // Retraso antes de cerrar para permitir navegar entre submenús
        timeout = setTimeout(() => {
          const siblingSubMenu = this.nextElementSibling;

          if (siblingSubMenu) {
            siblingSubMenu.classList.remove("sub-item-show");
            this.setAttribute("aria-expanded", "false");

            const icon = this.querySelector("i");
            if (icon) {
              icon.classList.remove("icon-rotate");
            }
          }
        }, 0);
      });

      // Asegurar que el submenú permanece abierto al mover el ratón entre el padre y el submenú
      const siblingSubMenu = subMenu.nextElementSibling;

      if (siblingSubMenu) {
        siblingSubMenu.addEventListener("mouseenter", () => {
          clearTimeout(timeout);
        });

        siblingSubMenu.addEventListener("mouseleave", () => {
          timeout = setTimeout(() => {
            siblingSubMenu.classList.remove("sub-item-show");
            subMenu.setAttribute("aria-expanded", "false");

            const icon = subMenu.querySelector("i");
            if (icon) {
              icon.classList.remove("icon-rotate");
            }
          }, 0);
        });
      }
    });

    // Evitar navegación no deseada al hacer clic en los íconos
    const navLinks = document.querySelectorAll(".nav-link");

    navLinks.forEach((link) => {
      link.addEventListener("click", function (e) {
        const icon = this.querySelector("i");
        const span = this.querySelector("span");

        if (e.target === span && this.href) {
          window.location.href = this.href;
        }

        if (e.target === icon) {
          e.preventDefault();
        }
      });
    });
    //END LIFERAY
  });
};

export const initCompC0003 = () => {

    document.addEventListener("DOMContentLoaded", function () {
//LIFERAY
        const navWrappers = document.querySelectorAll(".c0003-tabs.nav-wrapper");

        navWrappers.forEach((navWrapper) => {
            const nav = navWrapper.querySelector(".c0003-tabs-nav");
            const navContainer = navWrapper.querySelector(".c0003-tabs .nav-container");
            const navLinks = navContainer.querySelectorAll(".c0003-tabs .nav-link");
            const lastNavLink = navLinks[navLinks.length - 1];

            function checkOverflow() {
                const maxScrollLeft = navContainer.scrollWidth - navContainer.clientWidth;
              
                // ¿Hay overflow horizontal?
                const hasOverflow = maxScrollLeft > 0;
              
                // Mostrar difuminado a la derecha si aún queda contenido por ver
                navWrapper.classList.toggle("overflowing-right", hasOverflow && navContainer.scrollLeft < maxScrollLeft - 1);
              
                // Mostrar difuminado a la izquierda si ya se ha desplazado algo
                navWrapper.classList.toggle("overflowing-left", hasOverflow && navContainer.scrollLeft > 1);
              }
              

            // Function to scroll the nav container to make the focused element fully visible
            function scrollToElement(element) {
                const elementRect = element.getBoundingClientRect();
                const containerRect = navWrapper.getBoundingClientRect();

                if (elementRect.right > containerRect.right) {
                    navContainer.scrollLeft += elementRect.right - containerRect.right;
                } else if (elementRect.left < containerRect.left) {
                    navContainer.scrollLeft -= containerRect.left - elementRect.left;
                }
            }

            // Add focus event listeners to each nav link
            navLinks.forEach((link) => {
                link.addEventListener("focus", () => scrollToElement(link));
                checkOverflow();
            });

            // Check overflow on resize
            window.addEventListener("resize", checkOverflow);

            // Check overflow on scroll
            navContainer.addEventListener("scroll", checkOverflow);

            // Check overflow on initial load
            checkOverflow();
        });
        //END LIFERAY
    });
};

initCompC0003();



export const initCompC0026 = () => {

  document.addEventListener("DOMContentLoaded", function () {
//LIFERAY
    var goTop = $('#go-top');
    $(window).on('scroll', function () {
      if ($(window).scrollTop() > 200) {
        goTop.fadeIn();
      } else {
        goTop.fadeOut();
      }
    });

    goTop.click(function () {
      $('html, body').stop().animate(
          {
            scrollTop: 0,
          },
          500
      );
    });
//END LIFERAY
  });

}

initCompC0026();
export const initCompC0020 = (id, handleExternalClose = () => {}) => {
    //LIFERAY
    let toastElement
    if (id)
        toastElement = document.getElementById(id);
    else
        toastElement = document.querySelector('.toast');

    if (toastElement) {
        const toast = new bootstrap.Toast(toastElement, {
            animation: true,
            autohide: true,
            delay: 4000
        });

        toast.show();
    
        toastElement.addEventListener('hidden.bs.toast', function () {
            handleExternalClose();
        });
    }
    //END LIFERAY
}

export const initCompC0034 = () => {
  document.addEventListener('DOMContentLoaded', function () {
    //LIFERAY
    $(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
    //END LIFERAY
  });
};

initCompC0034();
export const initCompC0030 = () => {
  document.addEventListener('DOMContentLoaded', () => {
    //LIFERAY

    if (document.querySelectorAll('div.c0030-tree-filter').length) {
      const togglers = document.getElementsByClassName('c0030-tree-filter__branch');

      for (let i = 0; i < togglers.length; i++) {
        togglers[i].addEventListener('click', function () {
          const element = this.parentElement.querySelector('.c0030-tree-filter__nested')
          element.classList.toggle('active');
          if (element.classList.contains('active')){
            element.style.maxHeight = `${element.scrollHeight}px`;
            /*const parent = element.closests('c0030-tree-filter__nested.active')
            parent.style.maxHeight = `${parent.scrollHeight}px`;*/
          }else
            element.style.maxHeight = `0`;
          this.classList.toggle('c0030-tree-filter__branch-down');
        });
        
        const element = togglers[i].parentElement.querySelector('.c0030-tree-filter__nested')
        if (element.classList.contains('active')) 
          element.style.maxHeight = `${element.scrollHeight}px`;
        else
          element.style.maxHeight = `0`;
        

      }
    }
    //END LIFERAY
  })
};
